import React from 'react';
import styled from 'styled-components';

interface CardContentProps {
	children: JSX.Element | JSX.Element[];
}

export const Container = styled.div`
	width: 100%;
	height: 100%;
	padding: 2%;
	border-radius: 20px;
	background-color: ${({ theme }) => theme.palette.secondary[50]};
`;

export function CardContent({ children }: Readonly<CardContentProps>): JSX.Element {
	return <Container>{children}</Container>;
}
